import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from '../../dialogs/error-dialog/error-dialog.component';
import { TipoMarcacaoEnum } from '../../enums/tipo-marcacao-enum';
import { Filial } from '../../filial/filial';
import { MoedaFormatadaGenericaPipe } from '../../pipes/moeda-formatada-generica-pipe';
import { Procedimento } from '../../procedimento/procedimento';
import { ProcedimentoAgendaService } from '../../procedimento/procedimento-agenda/procedimento-agenda.service';
import { ProcedimentoService } from '../../procedimento/procedimento.service';
import { MarcacaoProcedimentoService } from '../marcacao-procedimento/marcacao-procedimento.service';
import { Marcacao } from '../marcacao-procedimento/marcacao';
import { MarcacaoComponent } from '../marcacao.component';

import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

interface AgendaDia {
  data: string;
  locais: AgendaLocal[];
}

interface AgendaLocal {
  filialId: number;
  nomeFilial: string;
  horarios: AgendaHorario[];
}

interface AgendaHorario {
  hora: string;
  mostrarMedico: boolean;
  marcacao: Marcacao;
}

const ExamesMostrarMedico = [
  {
    id: 38,
    nome: 'FOTOCOAGULAÇÃO',
  },
  {
    id: 65,
    nome: 'FOTOCOAGULAÇÃO',
  },
  {
    id: 34,
    nome: 'CAPSULOTOMIA POR YAG LASER',
  },
  {
    id: 75,
    nome: 'CAPSULOTOMIA POR YAG LASER',
  },
];

@Component({
  selector: 'app-selecao-procedimento',
  templateUrl: './selecao-procedimento.component.html',
  styleUrls: ['./selecao-procedimento.component.css'],
})
export class SelecaoProcedimentoComponent
  extends MarcacaoComponent
  implements OnInit
{
  // Mantém uma lista de Marcacao para cada item do FormArray, alinhada por índice

  // possiveisMarcacoes: Array<Marcacao> = [];

  public nenhumAgendamentoEncontrado: boolean = false;

  private _possiveisMarcacoes: Marcacao[] = [];

  get possiveisMarcacoes(): Marcacao[] {
    return this._possiveisMarcacoes;
  }

  set possiveisMarcacoes(value: Marcacao[]) {
    this._possiveisMarcacoes = value;

    // 🔄 sempre que mudar:
    this.updateFiliaisDisponiveis();
    this.applyFilters();
  }

  possiveisMarcacoesFiltradas: Marcacao[] = [];

  possiveisMarcacoesRemapeadas: AgendaDia[] = [];

  possiveisMarcacoesSelecionadas: Array<Marcacao> = [];

  listaDeProcedimento: Array<Procedimento> = [];

  procedimentosSelecionados: Procedimento[] = [];

  observacaoSelecaoProcedimento: string = '';

  // filtros para a listagem de exames disponiveis
  filtroProcedimentoId?: number | null = null;
  filtroFilialId?: number | null = null;
  filtroDataInicio?: string | null = null;
  filtroDataFim?: string | null = null;

  filiaisDisponiveis: Filial[] = [];
  constructor(
    private procedimentoService: ProcedimentoService,
    private procedimentoAgendaService: ProcedimentoAgendaService,
    private marcacaoProcedimentoService: MarcacaoProcedimentoService,
    router: Router,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private moedaFormatadaPipe: MoedaFormatadaGenericaPipe,
  ) {
    super(router);
  }

  ngOnInit(): void {
    this.configurarTitulo(
      '(Etapa 3 de 5)',
      TipoMarcacaoEnum.TIPO_MARCACAO_EXAME,
    );

    this.validarTelaSelecaoPaciente();

    this.configurarMarcacaoProcedimento();

    this.configurarListaDeProcedimento();
    
    this.reloadData();
  }

  reloadData() {
    if (history.state.procedimentosSelecionados) {
      this.procedimentosSelecionados = history.state.procedimentosSelecionados;
    } else {
      this.procedimentosSelecionados = [];
    }
  }

  configurarListaDeProcedimento(): void {
    this.procedimentoService
      .listarExamesPorPlanoSaudeDTO(this.marcacaoConsulta.planoSaude.id)
      .subscribe(
        (data) => {
          // console.log(data)
          this.listaDeProcedimento = data;
        },
        (error) => {
          this.listaDeProcedimento = [];
        },
      );
  }

  isExameSelecionado(exame: Procedimento): boolean {
    return this.procedimentosSelecionados.some(
      (procedimentoSelecionado) => procedimentoSelecionado?.id === exame.id,
    );
  }

  isPossivelMarcacaoSelecionada(marcacao: Marcacao): boolean {
    return this.possiveisMarcacoesSelecionadas.some(
      (procedimentoSelecionado) =>
        this._keyFromMarcacao(procedimentoSelecionado) ===
        this._keyFromMarcacao(marcacao),
    );
  }

  onToggleExame(exame: Procedimento): void {
    const jaSelecionado = this.isExameSelecionado(exame);

    if (jaSelecionado) {
      this.RemoverProcedimentoSelecionados(exame);
    } else {
      this.adicionarFormularioPorCheckbox(exame);
    }

    // this.AtualizarListaDeMarcacaoProcedimento();
  }

  adicionarFormularioPorCheckbox(exame: Procedimento): void {
    if (this.planoAceitaProcedimento(exame)) {
      exame.cobrarProcedimento = false;
      this.adicionarProcedimentoSelecionados(exame);
    } else {
      this.tratarProcedimentoParticular(exame);
    }
  }

  private adicionarProcedimentoSelecionados(procedimento: Procedimento) {
    const existe = this.procedimentosSelecionados.some(
      (p) => p.id === procedimento.id,
    );

    if (!existe) {
      this.procedimentosSelecionados.push(procedimento);
    }
  }

  private RemoverProcedimentoSelecionados(procedimento: Procedimento) {
    const existe = this.procedimentosSelecionados.find(
      (p) => p.id === procedimento.id,
    );

    if (existe) {
      // remove da lista de procedimentos selecionados
      this.procedimentosSelecionados = this.procedimentosSelecionados.filter(
        (p) => p.id !== procedimento.id,
      );

      // remove qualquer possivel marcacao selecionada que pertença a esse procedimento
      this.possiveisMarcacoesSelecionadas =
        this.possiveisMarcacoesSelecionadas.filter(
          (m) => m.procedimento?.id !== procedimento.id,
        );

      // desmarca também as possiveisMarcacoes atualmente exibidas para refletir a remoção
      this.possiveisMarcacoes = this.possiveisMarcacoes.map((m) => {
        if (m.procedimento?.id === procedimento.id) {
          m.marcacaoSelecionada = false;
        }
        return m;
      });
    }
  }

  public AtualizarListaDeMarcacaoProcedimento() {
    this.possiveisMarcacoes = [];

    if (!this.procedimentosSelecionados.length) return;

    const requests$ = this.procedimentosSelecionados.map((procedimento) =>
      this.marcacaoProcedimentoService
        .listarTodosExamesPorProcedimento(
          procedimento.id,
          this.marcacaoConsulta.planoSaude.id,
          this.marcacaoConsulta?.pacienteSelecionado?.id,
          this.marcacaoConsulta?.portadorNecessidade ?? false,
        )
        .pipe(
          // anexa o procedimento à resposta
          map((response: Marcacao[]) => ({ procedimento, response })),
        ),
    );

    forkJoin(requests$).subscribe({
      next: (results) => {
        const novasMarcacoes: Marcacao[] = [];

        for (const { procedimento, response } of results) {
          for (const marcacao of response) {
            marcacao.procedimento = procedimento;
            marcacao.cobrarProcedimento = procedimento.cobrarProcedimento;

            for (const dataDisponivel of marcacao.listaDatasDisponiveis) {
              for (const hora of dataDisponivel.horarios) {
                novasMarcacoes.push({
                  ...marcacao,
                  melhorData: dataDisponivel.data,
                  melhorHora: hora,
                  marcacaoSelecionada: false,
                  melhorHoraFormatada: this.formatarHora(hora),
                });
              }
            }
          }
        }

        // 🔄 sincroniza seleção
        const selectedKeys = new Set(
          this.possiveisMarcacoesSelecionadas.map((m) =>
            this._keyFromMarcacao(m),
          ),
        );

        this.possiveisMarcacoes = novasMarcacoes.map((pm) => ({
          ...pm,
          marcacaoSelecionada: selectedKeys.has(this._keyFromMarcacao(pm)),
        }));

        this.possiveisMarcacoesSelecionadas =
          this.possiveisMarcacoesSelecionadas.filter((sel) =>
            this.possiveisMarcacoes.some(
              (pm) => this._keyFromMarcacao(pm) === this._keyFromMarcacao(sel),
            ),
          );

        // atualiza lista de filiais disponiveis e aplica filtros (se houver)
        this.updateFiliaisDisponiveis();
        this.applyFilters();
      },
      error: (err) => {
        console.error('Erro ao listar exames', err);
      },
    });
  }

  formatarHora(valor: string | number): string {
    if (!valor) return '';

    const hora = valor.toString().padStart(4, '0');
    return `${hora.substring(0, 2)}:${hora.substring(2, 4)}`;
  }

  // Atualiza a lista de filiais disponíveis a partir das possiveisMarcacoes
  private updateFiliaisDisponiveis(): void {
    const map = new Map<number, Filial>();
    for (const m of this.possiveisMarcacoes) {
      if (m.filial && m.filial.id) {
        map.set(m.filial.id, m.filial);
      }
    }
    this.filiaisDisponiveis = Array.from(map.values());
  }

  private startOfDay(d: Date | string): Date {
    const dt = new Date(d);
    dt.setHours(0, 0, 0, 0);
    return dt;
  }

  private endOfDay(d: Date | string): Date {
    const dt = new Date(d);
    dt.setHours(23, 59, 59, 999);
    return dt;
  }

  applyFilters(): void {
    // 🔒 proteção: ainda não buscou nada
    if (!this.possiveisMarcacoes || this.possiveisMarcacoes.length === 0) {
      this.possiveisMarcacoesFiltradas = [];
      this.nenhumAgendamentoEncontrado = false;
      return;
    }

    this.possiveisMarcacoesFiltradas = this.possiveisMarcacoes.filter(
      (m, index) => {
        console.group(`🧪 Avaliando marcação #${index}`);
        console.log('Marcação:', m);

        // 🩺 Procedimento
        if (this.filtroProcedimentoId) {
          console.log(
            'Filtro procedimento:',
            this.filtroProcedimentoId,
            'Marcacao:',
            m.procedimento?.id,
          );

          if (m.procedimento?.id !== this.filtroProcedimentoId) {
            console.warn('❌ Rejeitado pelo filtro de procedimento');
            console.groupEnd();
            return false;
          }
        }

        // 🏥 Filial
        if (this.filtroFilialId) {
          console.log(
            'Filtro filial:',
            this.filtroFilialId,
            'Marcacao:',
            m.filial?.id,
          );

          if (m.filial?.id !== this.filtroFilialId) {
            console.warn('❌ Rejeitado pelo filtro de filial');
            console.groupEnd();
            return false;
          }
        }

        // 📅 Data início
        if (this.filtroDataInicio) {
          const dataMarcacao = new Date(m.melhorData);
          const dataInicio = this.startOfDay(this.filtroDataInicio);

          console.log('Filtro data início:', this.filtroDataInicio);
          console.log('Data da marcação:', dataMarcacao);
          console.log('Data início normalizada:', dataInicio);

          if (isNaN(dataMarcacao.getTime())) {
            console.error('❌ Data da marcação inválida');
            console.groupEnd();
            return false;
          }

          if (dataMarcacao < dataInicio) {
            console.warn('❌ Rejeitado por data menor que data início');
            console.groupEnd();
            return false;
          }
        }

        // 📅 Data fim
        console.log('filtroDataFim', this.filtroDataFim);

        if (this.filtroDataFim) {
          const dataMarcacao = new Date(m.melhorData);
          const dataFim = this.endOfDay(this.filtroDataFim);

          console.log('Filtro data fim:', this.filtroDataFim);
          console.log('Data da marcação:', dataMarcacao);
          console.log('Data fim normalizada:', dataFim);

          if (isNaN(dataMarcacao.getTime())) {
            console.error('❌ Data da marcação inválida');
            console.groupEnd();
            return false;
          }

          if (dataMarcacao > dataFim) {
            console.warn('❌ Rejeitado por data maior que data fim');
            console.groupEnd();
            return false;
          }
        }

        console.log('✅ Aprovado');
        console.groupEnd();
        return true;
      },
    );

    // ✅ aqui SIM decide se encontrou ou não
    this.nenhumAgendamentoEncontrado =
      this.possiveisMarcacoesFiltradas.length === 0;

    // mantem a marcação selecionada sincronizada
    const selectedKeys = new Set(
      this.possiveisMarcacoesSelecionadas.map((m) => this._keyFromMarcacao(m)),
    );
    this.possiveisMarcacoesFiltradas = this.possiveisMarcacoesFiltradas.map(
      (pm) => ({
        ...pm,
        marcacaoSelecionada: selectedKeys.has(this._keyFromMarcacao(pm)),
      }),
    );

    this.gerarPossiveisMarcacoesRemapeadas();
  }

  gerarPossiveisMarcacoesRemapeadas() {
    const agenda: AgendaDia[] = [];

    const ordenadas = [...this.possiveisMarcacoesFiltradas].sort((a, b) => {
      // Data
      const d1 = new Date(a.melhorData).getTime();
      const d2 = new Date(b.melhorData).getTime();
      if (d1 !== d2) return d1 - d2;

      // Local (Filial)
      if (a.filial.id !== b.filial.id) {
        return a.filial.nome.localeCompare(b.filial.nome);
      }

      // Hora
      return (a.melhorHoraFormatada || '').localeCompare(
        b.melhorHoraFormatada || '',
      );
    });

    ordenadas.forEach((m) => {
      // 1️⃣ Data (YYYY-MM-DD)
      const data = new Date(m.melhorData).toISOString().substring(0, 10);

      // 2️⃣ Dia
      let dia = agenda.find((d) => d.data === data);

      if (!dia) {
        dia = {
          data,
          locais: [],
        };
        agenda.push(dia);
      }

      // 3️⃣ Local (Filial)
      let local = dia.locais.find((l) => l.filialId === m.filial.id);

      if (!local) {
        local = {
          filialId: m.filial.id,
          nomeFilial: m.filial.nome,
          horarios: [],
        };
        dia.locais.push(local);
      }
      const examesComMedico = new Set(ExamesMostrarMedico.map((e) => e.id));

      const mostrarMedico = examesComMedico.has(m.procedimento.id);

      // 4️⃣ Horário
      local.horarios.push({
        hora: m.melhorHoraFormatada || m.horaAtendimento,
        marcacao: m,
        mostrarMedico: mostrarMedico,
      });
    });

    this.possiveisMarcacoesRemapeadas = agenda;
  }

  onDataInicioChange(data: string) {
    if (!data) return;
    this.filtroDataInicio = data;

    // Se a data fim for menor que a inicial, limpa
    if (this.filtroDataFim && this.filtroDataFim < data) {
      this.filtroDataFim = null;
    }

    this.applyFilters();
  }

  onDataFimChange(value: string | null): void {
    this.filtroDataFim = value;
    this.applyFilters();
  }

  resetFilters(): void {
    this.filtroProcedimentoId = null;
    this.filtroFilialId = null;
    this.filtroDataInicio = null;
    this.filtroDataFim = null;
    this.applyFilters();
  }

  onTogglePossivelMarcacao(marcacao: Marcacao): void {
    const key = this._keyFromMarcacao(marcacao);

    const selecionadaMesmoTipoIndex =
      this.possiveisMarcacoesSelecionadas.findIndex(
        (m) => this._keyFromMarcacao(m) === key,
      );

    // 🔴 Caso 1: clicou no mesmo tipo → desmarca
    if (selecionadaMesmoTipoIndex >= 0) {
      this.possiveisMarcacoesSelecionadas.splice(selecionadaMesmoTipoIndex, 1);
      return;
    }

    // 🟡 Caso 2: troca tipo do mesmo procedimento
    this.possiveisMarcacoesSelecionadas =
      this.possiveisMarcacoesSelecionadas.filter(
        (m) => m.procedimento.id !== marcacao.procedimento.id,
      );

    // 🟢 Adiciona o novo tipo
    this.possiveisMarcacoesSelecionadas.push(marcacao);
  }

  removerPossivelMarcacao(index: number): void {
    const marc = this.possiveisMarcacoesSelecionadas[index];
    if (!marc) return;
    const key = this._keyFromMarcacao(marc);

    // remove da lista de selecionadas
    this.possiveisMarcacoesSelecionadas.splice(index, 1);

    // desmarca também na lista geral de possiveisMarcacoes, se existir
    const encontrado = this.possiveisMarcacoes.find(
      (m) => this._keyFromMarcacao(m) === key,
    );
    if (encontrado) {
      encontrado.marcacaoSelecionada = false;
    }
  }

  private _keyFromMarcacao(m: Marcacao): string {
    const procId = m.procedimento?.id || 0;
    const filialId = m.filial?.id || 0;
    const medicoId = m.idMedico || 0;
    let dataStr = '';
    try {
      if (m.melhorData) {
        dataStr = new Date(m.melhorData).toISOString().split('T')[0];
      }
    } catch (e) {
      dataStr = String(m.melhorData || '');
    }
    const hora = m.melhorHora || '';

    return `${procId}|${filialId}|${medicoId}|${dataStr}|${hora}`;
  }

  private tratarProcedimentoParticular(procedimento: Procedimento): void {
    const msg = this.montarMensagemProcedimentoParticular(procedimento);

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirmação - Procedimento Particular',
        message: msg,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        procedimento.cobrarProcedimento = true;
        this.adicionarProcedimentoSelecionados(procedimento);
      } else {
        this.RemoverProcedimentoSelecionados(procedimento);
      }
    });
  }

  private montarMensagemProcedimentoParticular(
    procedimento: Procedimento,
  ): string {
    const plano = this.marcacaoConsulta.planoSaude;

    return `
    Seu Plano de Saúde (${plano?.nome || ''}) não aceita o procedimento
    (${procedimento.nome?.trim() || ''}).<br/>
    Deseja marcar esse procedimento de forma particular?<br/>
    Procedimento: ${procedimento.nome}<br/>
    Valor: ${this.moedaFormatadaPipe.transform(procedimento.valor)}<br/>
    Forma de Pagamento: Dinheiro
  `;
  }

  planoAceitaProcedimento(procedimento: Procedimento): boolean {
    if (!procedimento || !procedimento.id) {
      return false;
    }

    const plano = this.marcacaoConsulta?.planoSaude;

    if (!plano || !plano.planoSaudeProcedimento) {
      return false;
    }

    return plano.planoSaudeProcedimento.some(
      (p) => p.pk?.idProcedimento === procedimento.id,
    );
  }

  onSubmit() {
    this.proximaTela();
  }

  proximaTela(): void {
    this.router.navigate(['/marcacaoConsulta/selecionarAgendamento'], {
      state: {
        procedimentosSelecionados: this.procedimentosSelecionados,
        marcacaoConsulta: this.marcacaoConsulta,
      },
    });
    // this.salvarMarcacaExame();
  }

  telaAnterior(): void {
    this.router.navigate(['/marcacaoConsulta/selecionarPaciente'], {
      state: { marcacaoConsulta: this.marcacaoConsulta },
    });
  }

  salvarMarcacaExame(): void {
    // Validação: não permitir formulários duplicados
    if (!this.validarDuplicados()) {
      return;
    }

    // Prepara payload: envia apenas as marcações preenchidas (sincronizadas por índice)
    const payload = this.possiveisMarcacoesSelecionadas.map((m) => {
      // define usuário que está executando a marcação, se disponível
      try {
        if (
          (this as any).usuarioLogado &&
          (this as any).usuarioLogado.username
        ) {
          (m as any).loginUserMarcacao = (this as any).usuarioLogado.username;
        }
      } catch (e) {
        // ignore
      }
      return m;
    });

    this.marcacaoProcedimentoService
      .salvarMarcacoesProcedimento(payload)
      .subscribe(
        (data: any) => {
          // espera-se um array de respostas com { index, success, resposta, marcacaoProcedimento }
          const respostas: Array<any> = Array.isArray(data) ? data : [];

          const falhas = respostas.filter((r) => r.resposta != '0');

          if (falhas && falhas.length > 0) {
            // monta mensagem com cada falha e seu índice
            const mensagens = falhas
              .map(
                (f, index) =>
                  `Item [${index + 1}]: ${f.resposta || 'Erro desconhecido'}`,
              )
              .join('<br/>');

            this.dialog.open(ErrorDialogComponent, {
              data: {
                title: 'Algumas marcações não foram realizadas',
                message: mensagens,
              },
            });
          } else {
            // todas ok -> navegar para tela de realizado com a primeira marcação ou uma lista
            const marcacoesRealizadas = respostas
              .map((r) => r.marcacaoProcedimento)
              .filter((x) => x);
            // navega para a tela de finalização, passando o primeiro item (compat com fluxo anterior)
            this.router.navigate(
              ['/marcacaoConsulta/marcacaoProcedimentoRealizado'],
              {
                state: {
                  marcacaoProcedimento: marcacoesRealizadas[0] || null,
                  marcacoesProcedimento: marcacoesRealizadas,
                },
              },
            );
          }
        },
        (error) => {
          console.error(
            'salvarMarcacaExame -> erro na requisição batch:',
            error,
          );
          this.dialog.open(ErrorDialogComponent, {
            data: {
              title: 'Erro ao salvar marcações',
              message:
                'Ocorreu um erro ao enviar as marcações. Tente novamente mais tarde.',
            },
          });
        },
      );
  }

  /**
   * Valida se existem formulários duplicados no array de marcações.
   * Critério de igualdade: procedimento.id | filial.id | idMedico | melhorData(ISO date) | melhorHora
   * Retorna true se não houver duplicados; em caso contrário abre um diálogo de erro e retorna false.
   */
  private validarDuplicados(): boolean {
    const map = new Map<string, number[]>();

    for (let i = 0; i < this.possiveisMarcacoesSelecionadas.length; i++) {
      const m = this.possiveisMarcacoesSelecionadas[i] || ({} as any);
      const procId = m.procedimento?.id || 0;
      const filialId = m.filial?.id || 0;
      const medicoId = m.idMedico || 0;
      let dataStr = '';
      try {
        if (m.melhorData) {
          dataStr = new Date(m.melhorData).toISOString().split('T')[0];
        }
      } catch (e) {
        dataStr = String(m.melhorData || '');
      }
      const hora = m.melhorHora || '';

      const key = `${procId}|${filialId}|${medicoId}|${dataStr}|${hora}`;

      if (!map.has(key)) {
        map.set(key, [i]);
      } else {
        map.get(key)?.push(i);
      }
    }

    const duplicates = Array.from(map.entries()).filter(
      ([k, arr]) => arr.length > 1,
    );

    if (duplicates.length > 0) {
      // constrói mensagem mostrando os índices duplicados
      const parts = duplicates.map(
        ([k, arr]) => `Itens duplicados: [${arr.join(', ')}]`,
      );
      const message = `Existem formulários duplicados. ${parts.join(
        ' / ',
      )}. Remova duplicatas antes de finalizar a marcação.`;
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Validação - Formulários Duplicados',
          message: message,
        },
      });
      return false;
    }

    return true;
  }

  trackByMarcacao(index: number, marcacao: Marcacao) {
    return [
      marcacao.filial.id,
      marcacao.paciente.id,
      marcacao.planoSaude.id,
      marcacao.procedimento.id,
      new Date(marcacao.melhorData).getTime(),
      new Date(marcacao.horaAtendimento).getTime(),
    ].join('-');
  }
}
